import { Component, OnInit } from '@angular/core';
import { ReportsService } from 'src/app/services/reports.service';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';

@Component({
  selector: 'app-winningbets',
  templateUrl: './winningbets.component.html',
  styleUrls: ['./winningbets.component.scss'],
})
export class WinningbetsComponent implements OnInit {
  constructor(private reprotServ: ReportsService) {}

  date!: Date | null;
  winningbets: any;
  visible: any;
  Code: any;
  Name: any;

  ngOnInit() {
    this.date = new Date(moment().format('MM/DD/yyyy'));
    this.LoadGross();
  }

  LoadGross = () => {
    let newdate = this.date
      ?.toLocaleDateString('ja-JP', {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replaceAll('/', '-');
    let data = {
      date: newdate,
    };
    this.reprotServ.getWinningBets(data).subscribe((res) => {
      this.winningbets = res;
      console.log(res);
    });
  };

  exportExcel() {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.winningbets);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, 'products');
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
    );
  }
}
